import type { Home } from '@lmc/ts-common'
import { Tag } from '@lmc/ui-kit'
import { NAMESPACE } from 'locale'
import { selfServeConstants } from 'locale/selfServe'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

type HomeExtended = Home & { onTrial?: boolean }

export const ProTag: FC = () => {
  const { t } = useTranslation(NAMESPACE.SELF_SERVE)

  const home: Home | undefined = useSelector(
    (state: { global: { home: Home } }) => state.global.home
  )

  const hasPro = home?.features?.pro?.enabled

  const hasTrial = (home as HomeExtended)?.onTrial

  const hasTag = hasPro && hasTrial

  if (!hasTag) {
    return null
  }

  return (
    <StyledWrapper>
      <Tag data-cy="pro-tag" color="magenta">
        {t(selfServeConstants.PRO_FEATURE)}
      </Tag>
    </StyledWrapper>
  )
}

const StyledWrapper = styled.div`
  height: 100%;
  margin-top: auto;
  margin-bottom: auto;
  margin-right: auto;
  margin-left: 10px;
  display: flex;
`
